import "react-datepicker/dist/react-datepicker.css";
import { Button } from "../../Button";
import { Container, Row, Col } from "react-grid-system";
import { getUpperDecisionList } from "../../../api/decision/upper-decision";
import SimpleSearch from "../../SimpleSearch";
import { Select } from "../../Select";
import {
	StyledAddUpperDecisionIcon,
	StyledAddUpperDecisionOptions,
	StyledModalFooterActions,
} from "../../../styles/StyledAddUpperDecision";
import { StyledDatePickerWrapper } from "../../../styles/StyledDatePickerWrapper";
import { StyledEditField } from "../../../styles/StyledEditField";
import { useQuery } from "react-query";
import { useState } from "react";
import AddIcon from "../../../assets/img/icons/add.svg";
import CalendarIcon from "../../../assets/img/icons/calendar.svg";
import DatePicker from "react-datepicker";
import icon from "../../../assets/img/upper-decision.png";
import PropTypes from "prop-types";
import { SelectableSingleDecision } from "../../SelectableLists/SelectableDecisions";
import { useRef } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

export default function AddUpperDecision({ onClick, unit, matters, selectedUpperDecision }) {
	const { axiosPrivate } = useAxiosPrivate();

	const [startDate, setStartDate] = useState(null);
	const [decisionSelectedID, setDecisionSelectedID] = useState(null);
	const [phrase, setPhrase] = useState(null);
	const [searchValue, setSearchValue] = useState("");
	const [matterId, setMatterId] = useState(null);

	const matterRef = useRef();

	const { data, isLoading, isError, error } = useQuery(["unit-id", unit.value, matterId, startDate, phrase], () =>
		getUpperDecisionList(axiosPrivate, unit.value, matterId, startDate, phrase)
	);

	const handlePhraseChange = (newPhrase) => {
		setPhrase(newPhrase);
		setSearchValue(newPhrase);
	};

	const AddDecision = () => {
		const upperDecision = data.filter((el) => {
			if (el.id == decisionSelectedID) {
				return el;
			}
		});
		selectedUpperDecision(...upperDecision);
		onClick();
	};

	return (
		<>
			<Container>
				<Row>
					<Col sm={2}>
						<StyledAddUpperDecisionIcon>
							<img src={icon} alt="" />
						</StyledAddUpperDecisionIcon>
					</Col>
					<Col sm={10}>
						<StyledAddUpperDecisionOptions>
							<Row>
								<Col>
									<SimpleSearch isWhite value={searchValue} onChange={handlePhraseChange} />
								</Col>
							</Row>
							<Row align="start">
								<Col sm={8}>
									<StyledEditField>
										<label>matter</label>
										<Select
											options={[
												...matters.map((matter) => {
													return { value: matter.id, label: matter.name };
												}),
											]}
											setMatterId={setMatterId}
											ref={matterRef}
										/>
									</StyledEditField>
								</Col>
								<Col sm={4}>
									<StyledEditField>
										<label>Decision Date</label>
										<StyledDatePickerWrapper>
											<DatePicker
												selected={startDate}
												onChange={(date) => setStartDate(date)}
												placeholderText="Choose"
												autoComplete="off"
											/>
											<i>
												<img src={CalendarIcon} alt="date" />
											</i>
										</StyledDatePickerWrapper>
									</StyledEditField>
								</Col>
							</Row>
							<Row>
								<Col>
									<div style={{ display: "flex", justifyContent: "flex-end" }}>
										<Button
											onClick={() => {
												setStartDate(null);
												setMatterId(undefined);
												setPhrase(null);
												setSearchValue("");
												if (matterRef.current) {
													if (matterRef.current.props.value) {
														matterRef.current.props.value.value = null;
														matterRef.current.props.value.label = null;
													}
												}
											}}
											bg={false}
											small={true}
										>
											Clear filters
										</Button>
									</div>
								</Col>
							</Row>
						</StyledAddUpperDecisionOptions>
					</Col>
				</Row>
				<Row>
					<Col>
						<SelectableSingleDecision
							data={data}
							isLoading={isLoading}
							isError={isError}
							error={error}
							unit={unit}
							setSelectedDecisionID={setDecisionSelectedID}
						/>
					</Col>
				</Row>
				<Row>
					<Col>
						<StyledModalFooterActions>
							<Button onClick={onClick} bg={false} small={true}>
								cancel
							</Button>
							<Button icon={AddIcon} onClick={AddDecision}>
								ADD UPPER DECISION
							</Button>
						</StyledModalFooterActions>
					</Col>
				</Row>
			</Container>
		</>
	);
}

AddUpperDecision.propTypes = {
	onClick: PropTypes.func,
	selectedUpperDecision: PropTypes.func,
	unit: PropTypes.object,
	matters: PropTypes.array,
};
